import Vue, { ref } from 'vue';
import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';
import { HotelReviews, getHotelReviews, MAX_SIZE_REVIEWS } from '@widgets/hotelReviews';
import OurReviewsList from './ourReviews/OurReviewsList';
import TopHotelsReviews from './tophotels/TopHotelsReviews';

import './reviews.scss';

export default class HotelPageReviewsView extends Backbone.Epoxy.View {
    initialize() {
        this.hotelTrackingService = new HotelTrackingService();
        this.initDefaultState();
        this.initTabs();
        this.initTabEvents();
        this.initModules();
        this.initAnalytics();
        this.initDefaultActiveTabs();
    }

    initDefaultState() {
        this.topHotelReviewsLoaded = false;
        this.tripAdvisorData = ref(null);
        this.tripAdvisorRendered = false;
    }

    initModules() {
        this.loadTripAdvisorHotelReviews();

        this.topHotels = new TopHotelsReviews({
            el: this.$el.find('#reviews_tophotels .frame'),
        });

        this.ourReviewsList = new OurReviewsList({
            el: this.$el,
        });
    }

	initAnalytics() {
		this.ourReviewsList.model.once('change:numOfComments', () => {
			if(this.ourReviewsList.model.get('numOfComments')) {
                this.hotelTrackingService.trackAvailableTravelata();
			}
		});
        this.ourReviewsList.model.on('change:pageNumber', () => {
            this.hotelTrackingService.trackReviewsTravelataMoreClick();
        });

        document.querySelector('.show-all-reviews')?.addEventListener('click', () => {
            this.hotelTrackingService.trackTravelataShowAllClick();
        });

        document.querySelector('.js-open-review-form')?.addEventListener('click', () => {
            this.hotelTrackingService.trackTravelataNewReviewClick();
        });

        this.ourReviewsList.reviewForm.model.on('change:isReviewSent', () => {
            if(this.ourReviewsList.reviewForm.model.get('isReviewSent')) {
                this.hotelTrackingService.trackReviewsTravelataNewReviewSuccess();
            }
        });

        document.querySelector('.allReviewsLink')?.addEventListener('click', () => {
            this.hotelTrackingService.trackShowReviewsClick();
        });
	}
    initTabs() {
        this.$el.tabs();
    }
    

    initDefaultActiveTabs() {
        const reviewsSource = window.appConfig.hotelInfo?.reviewsSource;
        const allReviews = {
            topHotels: { active: 0 },
            travelata: { active: 1 },
            tripadvisor: { active: 2 },
        };

        const reviewsTabsEl = document.querySelector('#reviewsTabs');
        if (reviewsTabsEl && 'IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.hotelTrackingService.trackShowReviewsSource({ reviewsSource });
                        obs.disconnect();
                    }
                });
            });
            observer.observe(reviewsTabsEl);
        }
        $('#reviewsTabs').tabs(allReviews[reviewsSource]);
        this.$el.trigger('tabsactivate');
    }

    async loadTripAdvisorHotelReviews() {
        const options = {
            limit: MAX_SIZE_REVIEWS * 2,
            hotelId: window.appConfig.hotelInfo?.id,
            page: 1,
        };

        const res = await getHotelReviews(options);

        if (res.reviews?.length) {
            this.tripAdvisorData.value = res;
            this.hotelTrackingService.trackAvailableTripadvisor();
        } else {
            this.hideTripAdvisorTab();
        }
    }

    hideTripAdvisorTab() {
        this.$el.find("li").eq(2).hide();
    }

    renderTripAdvisor() {
        if (this.tripAdvisorRendered) {
            return;
        }

        new Vue({
            render: (h) => h(HotelReviews, {
                props: {
                    hotelId: window.appConfig.hotelInfo?.id,
                    initialHotelReview: this.tripAdvisorData, 
                }
            }),
        }).$mount('.js-block-tripadviser');

        this.tripAdvisorRendered = true;
    }

    async loadTopHotelsReviews() {
        try {
            await this.topHotels.load();
            this.topHotelReviewsLoaded = true;
            const noReviewElement = document.querySelector('.top-hotels__no-review');
            if(!noReviewElement) {
                this.hotelTrackingService.trackAvailableTophotels();
                document.querySelector('.reviews__container').addEventListener('click', (event) => {
                    if (event?.target?.closest('.TH-widget-review-wrap__big-link')) {
                        this.hotelTrackingService.trackReviewsTopHotelsMoreClick();
                    }
                })
            }
        } catch (error) {
            console.warn(error);
            this.$el.tabs('disable', 0);
        }
    }
    
    loadTravelataReviews() {
        this.ourReviewsList.load();
    }

    initTabEvents() {
        this.$el.one('click', () => {
            const sourceMap = {
                0: 'topHotels',
                1: 'travelata',
                2: 'tripadviser',
            }
            this.hotelTrackingService.trackReviewsSourceClick(sourceMap[this.$el.tabs('option', 'active')]);
            this.$el.on('tabsactivate', () => {
                this.hotelTrackingService.trackReviewsSourceClick(sourceMap[this.$el.tabs('option', 'active')]);
            });
        });

        this.$el.on('tabsactivate', (event) => {
            if (this.$el.tabs('option', 'active') === 2) {
                this.renderTripAdvisor();
                if(event.originalEvent) this.hotelTrackingService.trackReviewsTripadvisorClick();
            } else if (this.$el.tabs('option', 'active') === 1) {
                this.loadTravelataReviews();
                if(event.originalEvent) this.hotelTrackingService.trackReviewsTravelataClick();
            } else if (!this.topHotelReviewsLoaded) {
                this.loadTopHotelsReviews();
                if(event.originalEvent) this.hotelTrackingService.trackReviewsTopHotelsClick();
            }
        });
    }
}